import type { TTSLanguage, TTSVoice } from "~/types/textToSpeech"
import { TEMPLATES } from "~/utilities/articles"

export function isTextToSpeechExcluded(template: string): boolean {
  return template === TEMPLATES.MATH_TASK ||
    template === TEMPLATES.MATH_TASK_WITH_IMAGE ||
    template === TEMPLATES.QUIZ ||
    template === TEMPLATES.VIDEO ||
    template === TEMPLATES.SLIDES
}

export function mapLanguageToVoice(language: TTSLanguage): TTSVoice {
  const map: Record<TTSLanguage, TTSVoice> = {
    nb_NO: 7387, // Cathrin
  }
  return map[language]
}
